import React, { useState } from "react";

// MATERIAL UI COMPONENTS
import { StyledTextField } from "../styled/inputs/textInput";

const PhoneFilter = ({ selectedValue, onFilterChange }) => {
  const [queryString, setQueryString] = useState(null);

  const handleInputChange = (event) => {
    const value = event.target.value;
    const input = value.replace(/\D/g, ""); // Removes non-numeric characters
    setQueryString(value);
    onFilterChange(input);
  };

  return (
    <StyledTextField
      size="small"
      id="phone"
      name="phone"
      label="Telefone"
      fullWidth
      variant="outlined"
      value={queryString}
      onChange={handleInputChange}
    />
  );
};

PhoneFilter.displayName = "Telefone";

export default PhoneFilter;
